// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulkpg-inline-1 {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 12px;
}

.bulkpg-inline-2 {
  min-width: 900px;
  margin-bottom: 0;
}

.bulkpg-inline-3 {
  font-size: 11px;
}

.bulkpg-inline-4 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.bulkpg-inline-5 {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 600;
  color: #ef4444;
  margin-bottom: 12px;
}

.bulkpg-inline-6 {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.bulkpg-inline-7 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.bulkpg-inline-8 {
  margin-bottom: 12px;
}

.bulkpg-inline-9 {
  margin-top: 12px;
  font-size: 12px;
}

.bulkpg-inline-10 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.bulkpg-inline-11 {
  margin-bottom: 12px;
}

.bulkpg-inline-12 {
  margin-top: 12px;
  font-size: 12px;
}

.bulkpg-inline-13 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.bulkpg-inline-14 {
  margin-bottom: 12px;
}

.bulkpg-inline-15 {
  margin-top: 12px;
  font-size: 12px;
}

.bulkpg-inline-16 {
  margin-top: 18px;
  border-top: 1px solid #e2e8f0;
  padding-top: 14px;
}

.bulkpg-inline-17 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-18 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.bulkpg-inline-19 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.bulkpg-inline-20 {
  margin-bottom: 0;
}

.bulkpg-inline-21 {
  margin-bottom: 0;
}

.bulkpg-inline-22 {
  margin-bottom: 10px;
}

.bulkpg-inline-23 {
  margin-bottom: 10px;
}

.bulkpg-inline-24 {
  margin-bottom: 10px;
}

.bulkpg-inline-25 {
  margin-bottom: 10px;
}

.bulkpg-inline-26 {
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px;
  font-size: 12px;
}

.bulkpg-inline-27 {
  margin-top: 6px;
}

.bulkpg-inline-28 {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 700;
}

.bulkpg-inline-29 {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
}

.bulkpg-inline-30 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-31 {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.bulkpg-inline-32 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.bulkpg-inline-33 {
  margin-bottom: 10px;
}

.bulkpg-inline-34 {
  margin-bottom: 10px;
}

.bulkpg-inline-35 {
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
}

.bulkpg-inline-36 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-37 {
  margin-bottom: 10px;
}

.bulkpg-inline-38 {
  font-size: 12px;
  color: #f59e0b;
}

.bulkpg-inline-39 {
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
}

.bulkpg-inline-40 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-41 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.bulkpg-inline-42 {
  margin-top: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px;
  font-size: 12px;
}

.bulkpg-inline-43 {
  margin-top: 14px;
  border-top: 1px solid #e2e8f0;
  padding-top: 12px;
}

.bulkpg-inline-44 {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}

.bulkpg-inline-45 {
  font-size: 13px;
  font-weight: 700;
}

.bulkpg-inline-46 {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
}

.bulkpg-inline-47 {
  margin-bottom: 0;
}

.bulkpg-inline-48 {
  text-align: center;
  padding: 16px;
  color: #94a3b8;
}

.bulkpg-inline-49 {
  font-family: monospace;
  font-size: 11px;
}

.bulkpg-inline-50 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.bulkpg-inline-51 {
  margin-bottom: 0;
}

.bulkpg-inline-52 {
  margin-bottom: 0;
}

.bulkpg-inline-53 {
  margin-bottom: 10px;
}

.bulkpg-inline-54 {
  margin-bottom: 10px;
}

.bulkpg-inline-55 {
  margin-top: 16px;
  border-top: 1px solid #e2e8f0;
  padding-top: 14px;
}

.bulkpg-inline-56 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-57 {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 12px;
}

.bulkpg-inline-58 {
  margin-top: 6px;
}

.bulkpg-inline-59 {
  margin-bottom: 10px;
  color: #94a3b8;
  font-size: 12px;
}

.bulkpg-inline-60 {
  margin-bottom: 10px;
}

.bulkpg-inline-61 {
  margin-top: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
}

.bulkpg-inline-62 {
  margin-bottom: 0;
}

.bulkpg-inline-63 {
  text-align: center;
  padding: 18px;
  color: #94a3b8;
}

.bulkpg-inline-64 {
  font-family: monospace;
  font-size: 11px;
}

.bulkpg-inline-65 {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  background: #f8fafc;
}

.bulkpg-inline-66 {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 8px;
}

.bulkpg-inline-67 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.bulkpg-inline-68 {
  margin-bottom: 0;
}

.bulkpg-inline-69 {
  margin-bottom: 0;
}

.bulkpg-inline-70 {
  border: 1px solid #dbeafe;
  border-radius: 8px;
  background: #eff6ff;
  padding: 10px;
  font-size: 12px;
  margin-bottom: 10px;
}

.bulkpg-inline-71 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.bulkpg-inline-72 {
  margin-bottom: 0;
}

.bulkpg-inline-73 {
  margin-bottom: 0;
}

.bulkpg-inline-74 {
  margin-bottom: 0;
}

.bulkpg-inline-75 {
  margin-bottom: 10px;
}

.bulkpg-inline-76 {
  margin-bottom: 10px;
}

.bulkpg-inline-77 {
  margin-top: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow-x: auto;
}

.bulkpg-inline-78 {
  margin-bottom: 0;
}

.bulkpg-inline-79 {
  text-align: center;
  padding: 18px;
  color: #94a3b8;
}

.bulkpg-inline-80 {
  font-family: monospace;
  font-size: 11px;
}

.bulkpg-inline-81 {
  margin-top: 12px;
}

.bulkpg-inline-82 {
  color: #94a3b8;
}

.bulkpg-inline-83 {
  border-bottom: 1px solid #f1f5f9;
  padding: 8px 0;
}

.bulkpg-inline-84 {
  font-size: 12px;
  font-weight: 700;
}

.bulkpg-inline-85 {
  font-size: 12px;
}

.bulkpg-inline-86 {
  font-size: 11px;
  color: #94a3b8;
}

.bulkpg-dyn-1 {
  color: var(--bulkpg-1-color);
}

.bulkpg-dyn-2 {
  color: var(--bulkpg-2-color);
}

.bulkpg-dyn-3 {
  color: var(--bulkpg-3-color);
}

.bulkpg-dyn-4 {
  color: var(--bulkpg-4-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/HR/BulkPg.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".bulkpg-inline-1 {\n  overflow-x: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-2 {\n  min-width: 900px;\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-3 {\n  font-size: 11px;\n}\n\n.bulkpg-inline-4 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-5 {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #ef4444;\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-6 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.bulkpg-inline-7 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-8 {\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-9 {\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-10 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-11 {\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-12 {\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-13 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-14 {\n  margin-bottom: 12px;\n}\n\n.bulkpg-inline-15 {\n  margin-top: 12px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-16 {\n  margin-top: 18px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 14px;\n}\n\n.bulkpg-inline-17 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-18 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.bulkpg-inline-19 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-20 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-21 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-22 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-23 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-24 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-25 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-26 {\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 10px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-27 {\n  margin-top: 6px;\n}\n\n.bulkpg-inline-28 {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bulkpg-inline-29 {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.bulkpg-inline-30 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-31 {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-32 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.bulkpg-inline-33 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-34 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-35 {\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.bulkpg-inline-36 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-37 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-38 {\n  font-size: 12px;\n  color: #f59e0b;\n}\n\n.bulkpg-inline-39 {\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.bulkpg-inline-40 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-41 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.bulkpg-inline-42 {\n  margin-top: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  padding: 10px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-43 {\n  margin-top: 14px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 12px;\n}\n\n.bulkpg-inline-44 {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-45 {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.bulkpg-inline-46 {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow-x: auto;\n}\n\n.bulkpg-inline-47 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-48 {\n  text-align: center;\n  padding: 16px;\n  color: #94a3b8;\n}\n\n.bulkpg-inline-49 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.bulkpg-inline-50 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-51 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-52 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-53 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-54 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-55 {\n  margin-top: 16px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 14px;\n}\n\n.bulkpg-inline-56 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-57 {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 10px;\n  margin-bottom: 10px;\n  font-size: 12px;\n}\n\n.bulkpg-inline-58 {\n  margin-top: 6px;\n}\n\n.bulkpg-inline-59 {\n  margin-bottom: 10px;\n  color: #94a3b8;\n  font-size: 12px;\n}\n\n.bulkpg-inline-60 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-61 {\n  margin-top: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow-x: auto;\n}\n\n.bulkpg-inline-62 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-63 {\n  text-align: center;\n  padding: 18px;\n  color: #94a3b8;\n}\n\n.bulkpg-inline-64 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.bulkpg-inline-65 {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n  margin-bottom: 12px;\n  background: #f8fafc;\n}\n\n.bulkpg-inline-66 {\n  font-size: 13px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.bulkpg-inline-67 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-68 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-69 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-70 {\n  border: 1px solid #dbeafe;\n  border-radius: 8px;\n  background: #eff6ff;\n  padding: 10px;\n  font-size: 12px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-71 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-72 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-73 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-74 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-75 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-76 {\n  margin-bottom: 10px;\n}\n\n.bulkpg-inline-77 {\n  margin-top: 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  overflow-x: auto;\n}\n\n.bulkpg-inline-78 {\n  margin-bottom: 0;\n}\n\n.bulkpg-inline-79 {\n  text-align: center;\n  padding: 18px;\n  color: #94a3b8;\n}\n\n.bulkpg-inline-80 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.bulkpg-inline-81 {\n  margin-top: 12px;\n}\n\n.bulkpg-inline-82 {\n  color: #94a3b8;\n}\n\n.bulkpg-inline-83 {\n  border-bottom: 1px solid #f1f5f9;\n  padding: 8px 0;\n}\n\n.bulkpg-inline-84 {\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bulkpg-inline-85 {\n  font-size: 12px;\n}\n\n.bulkpg-inline-86 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.bulkpg-dyn-1 {\n  color: var(--bulkpg-1-color);\n}\n\n.bulkpg-dyn-2 {\n  color: var(--bulkpg-2-color);\n}\n\n.bulkpg-dyn-3 {\n  color: var(--bulkpg-3-color);\n}\n\n.bulkpg-dyn-4 {\n  color: var(--bulkpg-4-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
